import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  Input,
  Select,
  Loader,
  Text,
  EmptyState,
} from "@flexisaf/flexibull2";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  getPapersStart,
  setCurrentPaper,
  deletePaperStart,
} from "../../../redux/paper/reducer";
import PaperEditor from "../../paper/modals/paperEditor";
import { PaperCardList } from "../../../components/CardList";
import usePapersGet from "../../../hooks/papers/usePapersGet";

import Theme from "../../../theme";
import { setCurrentExam } from "../../../redux/exam/reducer";
import { selectCurrentExam } from "../../../redux/exam/selectors";
import { FlexiPagination } from "@flexisaf/flexibull2/build/table";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";

const Papers = () => {
  const [modal, setModal] = useState({
    show: false,
    data: null,
  });
  const [deletePaperModal, setDeletePaperModal] = useState({
    openModal: false,
    data: null,
  });


  const navigate = useNavigate();

  const activeExam = useSelector(selectCurrentExam);
  const dispatch = useDispatch();
  const { id } = useParams();
  const { loadingPapers, papers, refetch, pageOptions,totalElements,limit,setPage,setLimit,page,setSearchText, searchText,isActive,
    setIsActive } = usePapersGet({ id });
    const list = papers?.items;

  const onEdit = (data) => {
    setModal({
      show: true,
      data,
    });
  };

  const onDelete = (data) => {
    let payload = {
      id: data.id,
      callback: () => {
        dispatch(getPapersStart(id));
        refetch()
      },
    };
    dispatch(deletePaperStart(payload));
  };

  return (
    <Box>
      <Grid default="max-content max-content auto max-content">
        <Input
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          iconLeft="saf-search-normal"
          placeholder="Search paper name"
          width="300px"
        />

        <Box>
          <Select
            placeholder="Status"
            options={[
              { label: "All", value: "" },
              { label: "Active", value: "ACTIVE" },
              { label: "Inactive", value: "INACTIVE" },
            ]}
            onChange={(e)=>setIsActive({...isActive, value:e.value})}
          />
        </Box>
        <Box />

        <Button
          onClick={() => {
            setModal({
              show: true,
              data: null,
            });
          }}
          alignRight
        >
          <Text>Create Paper</Text>
        </Button>
      </Grid>

      <Box margin="30px 0">
        {loadingPapers ? (
          <Box pad="150px 0">
            <Loader color={Theme.PrimaryColor} section />
          </Box>
        ) : list?.length > 0 ? (
          <>
          <Grid default="1fr 1fr 1fr 1fr" gap="2rem">
            {list.map((paper) => (
              <PaperCardList
              key={paper.id}
              handleRedirect={() => {
                dispatch(setCurrentPaper(paper));
                dispatch(setCurrentExam(activeExam));
                navigate(`/papers/${paper.id}`);
              }}
              handleEdit={() => onEdit(paper)}
              handleDelete={() => {
                setDeletePaperModal({openModal: true, data:paper})
              }}
              paperData={paper}
              status="active"
              questionCount="20"
              />
              ))}
          </Grid>
          <FlexiPagination
                pageCounts={pageOptions}
                itemsDisplayed
                total={totalElements}
                pageSize={limit}
                onChange={(page) => {
                  setPage(page);
                }}
                changePageSize={({ value }) => {
                  setPage(1);
                  setLimit(value);
                }}
                current={page}
              />
              </>
        ) : (
          <>
            <Box align="center">
              <EmptyState
                type="documents"
                title="You have not created any paper"
                info="Please create a paper to proceed"
              />
            </Box>
          </>
        )}
      </Box>

      <PaperEditor
        open={modal.show}
        data={modal.data}
        cbProps={{ refetchPaper: false, refetchPapers: refetch }}
        closeModal={() => {
          setModal({
            show: false,
            data: null,
          });
        }}
      />
      <DeleteModal
        isOpen={deletePaperModal.openModal}
        onClose={() =>
          setDeletePaperModal({ openModal: false, data: null })
        }
        title="Delete Paper"
        description="The execution of this action will result in the removal of the paper and all of its associated subjects from the system."
        isLoading={loadingPapers}
        onDelete={() => {
          onDelete(deletePaperModal?.data);
          setDeletePaperModal({ openModal: false, data: null });
        }}
      />
    </Box>
  );
};

export default Papers;
